export type USPType = {
  icon: React.ReactNode;
  description: React.ReactNode;
  title: string;
};

export const USP = ({ icon, description, title }: USPType) => {
  return (
    <div className="flex flex-row gap-x-4 text-dark-secondary text-xs mobile:text-base items-center">
      <div className="shrink-0 mb-auto">{icon}</div>
      <div className="flex flex-col gap-y-1">
        <p className="text-white text-lg font-semibold">{title}</p>
        <p className="text-dark-tertiary">{description}</p>
      </div>
    </div>
  );
};
